import { HttpInterceptorFn } from '@angular/common/http';
import { inject, Injector } from '@angular/core';
import { finalize } from 'rxjs';
import { SpinnerService } from '@mapfre-tech/amap3'
import { Router } from '@angular/router';

let _loadingCount = 0;

const screensWithoutLoading = [
  'pages/dashboard',
  '/pages/works/#/detail',
  '/pages/works/#/tracking',
  '/pages/recommendations/dashboard'
];

function isScreenIncluded(routerUrl: string): boolean {
  return screensWithoutLoading.some(screen => {
    const screenPaths = screen.split('#');
    return screenPaths.every(s => routerUrl.includes(s));
  });
}

function isUrlExcluded(reqUrl: string, baseUrl: string): boolean {
  return reqUrl.includes(`${baseUrl}/risk-assign`);
}

export const LoadingInterceptor: HttpInterceptorFn = (req, next) => {
  const spinnerService = inject(SpinnerService);
  const router = inject(Router);
  const injector = inject(Injector);
  const environment: any = injector.get('environment');

  const shouldSkipLoading = isScreenIncluded(router.url) || isUrlExcluded(req.url, environment.base_URL);

  if (!shouldSkipLoading) {
    _loadingCount += 1;
    spinnerService.loading(true);
  }

  return next(req).pipe(
    finalize(() => {
      const skip = isScreenIncluded(router.url) || isUrlExcluded(req.url, environment.base_URL);
      if (skip) {
        _loadingCount = 0;
        spinnerService.loading(false);
      } else {
        _loadingCount -= 1;
        if (_loadingCount <= 0) {
          spinnerService.loading(false);
        }
      }
    })
  );
};
